import { render, staticRenderFns } from "./agregarTarea.vue?vue&type=template&id=41815cbf"
import script from "./agregarTarea.vue?vue&type=script&lang=js"
export * from "./agregarTarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports